export const GET_TABLERO = 'GET_TABLERO'
export const GET_TABLERO_SUCCESS = 'GET_TABLERO_SUCCESS'
export const GET_TABLERO_ERROR = 'GET_TABLERO_ERROR'
export const GET_TABLERO_VERSION = 'GET_TABLERO_VERSION'
export const TABLERO_VERSION_ERROR = 'TABLERO_VERSION_ERROR'
export const CHANGE_APPLICANT_MARK = 'CHANGE_APPLICANT_MARK'

export interface Card {
  id: number
  idPostulacion?: number
  nombre: string
}

export interface Columna {
  id: string
  titulo: string
  cards: Card[]
}

export interface Tablero {
  avisoId: number
  avisoTitulo: string
  version: number
  columnas: Columna[]
}

export interface TableroState {
  tablero: Tablero | null
  loading: boolean
  error: boolean
  versionError: boolean
}

export const InitialState: TableroState = {
  tablero: null,
  loading: true,
  error: false,
  versionError: false,
}

export interface GetTablero {
  type: typeof GET_TABLERO
  payload: null
}

export interface GetTableroSuccess {
  type: typeof GET_TABLERO_SUCCESS
  payload: Tablero
}

export interface GetTableroError {
  type: typeof GET_TABLERO_ERROR
  payload: boolean
}

export interface GetTableroVersion {
  type: typeof GET_TABLERO_VERSION
  payload: Tablero
}

export interface TableroVersionError {
  type: typeof TABLERO_VERSION_ERROR
  payload: boolean
}

export interface ChangeApplicantMark {
  type: typeof CHANGE_APPLICANT_MARK
  payload: Tablero
}


export type TableroActions = GetTablero | GetTableroSuccess | GetTableroError | GetTableroVersion | TableroVersionError | ChangeApplicantMark
